//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import CustomerMainTabs from '@/views/customer/CustomerMainTabs'

//
import SlCustomerListView from '@/views/Sale/SlCustomer/SlCustomerList'
import SlCustomerDebtListView from '@/views/Sale/SlCustomer/SlCustomerDebtList'

//
export default {
    path: 'customer',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'customer-list',
            component: SlCustomerListView,
        },
        {
            path: 'debts',
            name: 'customer-debts',
            component: SlCustomerDebtListView,
            meta: {
                title: 'Cuentas por cobrar',
            },
        },
        {
            path: ':id',
            name: 'customer-update',
            component: CustomerMainTabs,
            meta: {
                title: 'Detalle cliente',
            },
        },
    ],
    meta: {
        title: 'Clientes',
    },
}
